<template>
  <div class="content new-order form">
    <!-- sales -->
    <div class="row">
      <sales :ChangeDisabled="ChangeActionDisabled" @refresh="RefreshDate" />
    </div>
    <!-- contractparty -->
    <div class="row">
      <contractparty />
    </div>
    <!-- product -->
    <div class="row">
      <product />
    </div>
    <!-- contract list -->
    <div class="row">
      <contracts @open="OpenContract" />
    </div>
    <!-- 操作 -->
    <div class="row">
      <div style="width: 100%; display: flex">
        <div style="text-align: left">
          <base-button
            class="btn-urgent"
            v-if="useOrder.getOrderFunctionPermission('VoidOrder')?.enable"
            :disabled="
              useOrder.getOrderFunctionPermission('VoidOrder')?.disable
            "
            @click="toVoid"
            >Void</base-button
          >
        </div>
        <div style="flex-grow: 1; text-align: right">
          <div
            style="column-gap: 5px; display: flex; justify-content: flex-end"
          >
            <base-button
              v-if="isEdit"
              :disabled="useOrder.getOrderFunctionPermission('Edit')?.disable"
              type="primary"
              @click="EditEvent"
              >Edit</base-button
            >
            <base-button
              v-if="isSave"
              :disabled="useOrder.getOrderFunctionPermission('Edit')?.disable"
              type="primary"
              @click="SaveEvent"
              >Save</base-button
            >

            <base-button @click="CloseEvent">Close</base-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, h } from 'vue';
import baseButton from '@/components/newUI/BaseButton';
import baseInput from '@/components/newUI/Inputs/BaseInput';
import router from '@/router/index';
import { useRoute } from 'vue-router';

//vue
import { useOrderStore } from '@/store/order.js';
import { storeToRefs } from 'pinia';
import { routeParamsStore } from '@/store/routeParams';

// api
import booknet from '@/network/booknet.js';
// components
import sales from '@/views/order/sales/index';
import contractparty from '@/views/order/contractparty/index';
import product from '@/views/order/product/index';
import contracts from '@/views/order/contracts/index';
import './css/index.css';
import { ElMessage, ElMessageBox } from 'element-plus';

// 当前页面的状态
var mode = ref('');

const routeParams = routeParamsStore();

const route = useRoute();

// 提示配置
const messageConfig = require('@/models/messageConfig.js');

// Data
const VoidComment = ref(''); //作废说明

// 设置页面参数
const setPageParam = (key, pageMode) => {
  var param = {
    key,
    mode: pageMode,
  };

  routeParams.UpdatePageParam(param);
};

const changeMode = (value) => {
  mode.value = value;
  useOrder.changeMode(mode.value);
};

const orderno = ref(route.query.OrderNo);
setPageParam(orderno.value);

// 加载Order Store
const useOrder = useOrderStore();
var Unit = useOrder.getUnit();

useOrder.$reset();
useOrder.setUnit(Unit);
changeMode(routeParams.getPageMode() || 'view');

// 页面刷新前处理
window.onbeforeunload = () => {
  var key = useOrder.OrderNumber;
  routeParams.setPageParam({
    key,
    mode: mode.value,
  });

  // routeParams.PageParam.OrderNo = key;
  // routeParams.PageParam.PageMode = mode.value;
};

await useOrder.getOrder(orderno.value);

const { Order, isAlertMessage, AlertMessages, disabled } =
  storeToRefs(useOrder);

// OrderFunctions
const isEdit = ref(false);
const isSave = ref(false);
var EditFunction = useOrder.getOrderFunctionPermission('Edit');
isEdit.value = EditFunction.enable && useOrder.isEditButton;
isSave.value = EditFunction.enable && !isEdit.value;

// 点击放大镜
const OpenContract = async (obj) => {
  if (!disabled.value) {
    const isSave = await Save().then((res) => res);
    if (!isSave) {
      return;
    }
  }
  if (obj.tabName === 'DraftContract') {
    const validate = obj.bDraftContract || false;

    var message = messageConfig.getMessage('draftvalid1');
    if (!validate) {
      ElMessage({
        message,
        type: 'warning',
      });
      return;
    }
  }

  changeMode('view');

  router.push({
    name: 'contract',
    query: {
      ContractNo: obj.contractNo,
      cId: obj.cId,
    },
  });
};

// #region nextbar event
const SaveEvent = async () => {
  var message = useOrder.getOrderFunctionPermission('Edit')?.disableMessage;

  if (message) {
    ElMessage({
      message,
      type: 'warning',
    });
    return;
  }

  changeOrderBusinessCategory();

  const res = await Save().then((res) => res);
  if (res) {
    isSave.value = false;
    isEdit.value = true;

    //routeParams.orderParams.mode = 'view';
    changeMode('view');

    ElMessage({
      message: messageConfig.getMessage('savesuccess'),
      type: 'success',
    });
    // await useOrder.getOrder(useOrder.OrderNumber);
    router.replace({
      name: 'order',
      query: {
        OrderNo: useOrder.OrderNumber,
      },
    });
  }
};

const Save = async () => {
  // valid
  var message = await SaveValid().then((res) => res);
  var OrderInfo = {};

  // 保存Contract Party
  if (message === '') {
    // 订单主信息
    OrderInfo = {
      Id: useOrder.Order.id,
      OrderNumber: useOrder.Order.orderNumber,
      AdvertiserCode: useOrder.Order.advertiserCode,
      AdvertiserName: useOrder.Order.advertiserName,
      ClientType: useOrder.Order.clientType,
      BusinessNature: useOrder.Order.businessNature,
      IsClientPermission: useOrder.Order.isClientPermission,
      IsClientKeyAcc: useOrder.Order.isClientKeyAcc,
      IsClientBR: useOrder.Order.isClientBR,
      IsClientTax: useOrder.Order.isClientTax,
      IsNewClient: useOrder.Order.isNewClient,
      AgencyCode: useOrder.Order.agencyCode,
      AgencyName: useOrder.Order.agencyName,
      AgencyType: useOrder.Order.agencyType,
      IsAgencyBR: useOrder.Order.isAgencyBR,
      IsAgencyBRExpired: useOrder.Order.isAgencyBRExpired,
      IsNewAgency: useOrder.Order.isNewAgency,
      IsAgencyDiscount: useOrder.Order.isAgencyDiscount,
      AgencyDiscount: useOrder.Order.agencyDiscount,
      BillNameId: useOrder.Order.billNameId,
      BillName: useOrder.Order.billName,
      BillAddress: useOrder.Order.billAddress,
      Status: useOrder.Order.status,
      ClientBRExpired: useOrder.Order.clientBRExpired,
      AgencyBRExpired: useOrder.Order.agencyBRExpired,
      CompanyAlerts: useOrder.Order.companyAlerts,
      BusinessUnit: useOrder.Order.businessUnit,
      ReferralCode: useOrder.Order.referralCode,
      ReferralName: useOrder.Order.referralName,
    };

    // Sales
    const OrderSales = useOrder.Sales;
    OrderInfo.SalesmanCode = OrderSales.salesmanCode;
    OrderInfo.Salesman = OrderSales.salesman;
    OrderInfo.TeamHeadCode = OrderSales.teamHeadCode;
    OrderInfo.TeamHead = OrderSales.teamHead;
    OrderInfo.SalesHeadCode = OrderSales.salesHeadCode;
    OrderInfo.SalesHead = OrderSales.salesHead;
    OrderInfo.PoolHeadCode = OrderSales.poolHeadCode;
    OrderInfo.PoolHead = OrderSales.poolHead;
    OrderInfo.effectiveDate = OrderSales.effectiveDate;

    // Business Category
    OrderInfo.BusinessCategories = useOrder.BusinessCategories;

    // Contact
    OrderInfo.Contacts = useOrder.ContactPersons;

    // Product
    OrderInfo.ProductName = useOrder.Product.productName;
    OrderInfo.IsNewProduct = useOrder.Product.isNewProduct;

    // Product Category
    OrderInfo.ProductCategories = useOrder.ProductCategoryList;

    const order_res = await booknet.saveOrderInfo(OrderInfo).then((res) => res);

    if (useOrder.OrderNumber === '') {
      useOrder.OrderNumber = order_res.data.order.orderNumber;
      useOrder.Id = order_res.data.order.id;
      useOrder.Order = order_res.data.order;
      useOrder.Sales = order_res.data.sales;
      useOrder.BusinessCategories = order_res.data.businessCategories;
      useOrder.ContactPersons = order_res.data.contactPersons;
      useOrder.SalesRecords = order_res.data.salesRecords;
      useOrder.Product = order_res.data.product;
      useOrder.Contracts = order_res.data.contracts;
      useOrder.ProductCategoryList = order_res.data.productCategories;
      useOrder.OrderFunctions = order_res.data.orderFunctions;
    }
  }

  if (message !== '') {
    ElMessage({
      message,
      type: 'warning',
    });
    return false;
  }
  return true;
};

const SaveValid = async () => {
  const message = useOrder.VaidationOrder();
  // const message =
  //   Object.values(useOrder.OrderRules).filter((t) => !t.validation)?.[0]
  //     ?.message || '';

  return message;
};

const changeOrderBusinessCategory = () => {
  // 更新Business Category
  const arrs =
    useOrder.BusinessCategories.filter(
      (t) => useOrder.OrderBusinessCategoryIds.indexOf(t.businessCategoryId) < 0
    ) || [];

  // 删除
  arrs.forEach((item) => {
    const index = useOrder.BusinessCategories.find(
      (t) => t.businessCategoryId === item.businessCategoryId
    );
    useOrder.BusinessCategories.splice(index, 1);
  });

  const OrderCategoryIds =
    useOrder.BusinessCategories?.length == 0
      ? []
      : useOrder.BusinessCategories.map((t) => t.businessCategoryId);
  const CategoryIds =
    useOrder.OrderBusinessCategoryIds.filter(
      (t) => OrderCategoryIds.indexOf(t) < 0
    ) || [];
  CategoryIds.forEach((item) => {
    const cateogry = useOrder.BusinessOptions.find((t) => t.id === item);
    useOrder.BusinessCategories.push({
      id: 0,
      businessCategoryId: item,
      code: cateogry.code,
      name: cateogry.name,
      status: 'Active',
    });
  });
};

// Edit
const EditEvent = () => {
  var message = useOrder.getOrderFunctionPermission('Edit').disableMessage;
  if (message) {
    ElMessage({
      message,
      type: 'warning',
    });
    return;
  }

  isEdit.value = false;
  isSave.value = true;
  changeMode('edit');
};

const CloseEvent = async () => {
  var action;
  if (!disabled.value) {
    const DiscardMessageBox =
      require('@/components/discardMessage/discardMessage').default;
    action = await DiscardMessageBox({
      message: 'Do you want to save or discard this page?',
      title: 'Discard Order',
      distinguishCancelAndClose: true,
      confirmButtonText: 'Save',
      cancelButtonText: 'Discard',
      closeButtonText: 'Cancel',
    })
      .then(() => {
        return 'save';
      })
      .catch((action) => {
        return action;
      });
  }

  if (action === 'save') {
    var result = await Save().then((res) => res);
    if (!result) {
      return;
    } else {
      ElMessage({
        message: messageConfig.getMessage('savesuccess'),
        type: 'success',
      });
    }
  }

  if (action !== 'close') {
    window.close();
    // if (routeParams.home === 'myTask') {
    //   // routeParams.home = '';
    //   router.replace({
    //     name: 'MyTask',
    //   });
    //   return;
    // }
    // router.replace({
    //   name: 'report',
    // });
  }
};

const toVoid = () => {
  VoidComment.value = '';

  var message = useOrder.getOrderFunctionPermission('VoidOrder')?.alertMessage;
  if (message) {
    ElMessageBox.alert(message, '', {});
  } else {
    var confirmMessage = h('p', null, [
      h(
        'div',
        {
          style: 'padding-bottom:18px',
        },
        'If you confirm to void the order, ALL contract(s) in this order will be automatically invalid at the same time.'
      ),
      h(
        'div',
        { style: 'padding-bottom:18px' },
        'Are you sure to void the order?'
      ),
      h('div', null, [
        h('span', null, 'Remark'),
        h('span', { style: 'color:red' }, '*'),
      ]),
      h(baseInput, {
        modelValue: VoidComment.value,
        'onUpdate:modelValue': (val) => {
          VoidComment.value = val;
        },
      }),
    ]);

    ElMessageBox({
      title: 'Void Order',
      message: confirmMessage,
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      customClass: 'matrix-message-box',
      confirmButtonClass: 'right-confirm-1',
      beforeClose: (action, instance, done) => {
        if (action == 'confirm') {
          if (!VoidComment.value) {
            if (instance.customClass.indexOf('is-error') == -1) {
              instance.customClass = instance.customClass + ' is-error';
            }
            instance.message.children[3].component.props.error =
              'Please fill in mandatory!';
          } else {
            instance.customClass = instance.customClass.replace(
              ' is-error',
              ''
            );
            instance.message.children[3].component.props.error = '';

            done();
          }
        } else {
          done();
        }
      },
    })
      .then(() => {
        booknet.VoidOrder(useOrder.Id, VoidComment.value).then(async (res) => {
          if (res.data.message) {
            ElMessage({
              message: res.data.message,
              type: 'warning',
            });
            return;
          }
          ElMessage({
            message: 'Void success.',
            type: 'success',
          });
          await useOrder.getOrder(orderno.value);
        });
      })
      .catch(() => {});
  }
};

const RefreshDate = () => {
  booknet.UpdateDate(Order.value.id).then((t) => {
    if (t.data?.message) {
      ElMessage({
        message: t.data.message,
        type: 'warning',
      });
      return;
    }
    Order.value.updateDate = t.data.updateDate;
  });
};
</script>

<style scoped>
.new-order h4 {
  color: #3b291d;
}

.new-order h5 {
  color: #423022;
}

.sales-title h4.sub {
  margin-left: 54px;
  display: inline-block;
  font-size: 11px;
}

.sales-title i {
  position: relative;
  top: -1px;
  right: 4px;
}

.new-order .el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
  padding-bottom: 6px;
}

.advertiser-field .form-group.has-label label::after {
  content: '【 Contracting Party 】';
  color: #d05c5f;
}

.sub-info {
  font-size: 10px;
  color: #9a9a9a;
  margin-left: 30px;
}

.sub-info .dot {
  width: 5px;
  height: 5px;
  background-color: rgb(169, 169, 169);
  display: inline-block;
  border-radius: 50%;
  top: -1px;
  position: relative;
  right: 2px;
}

.Rectangle {
  width: 160px;
  height: 32px;
  margin: 20px 1474.6px 0 0;
  padding: 6px 15px 6px 58px;
  border-radius: 6px;
  background-image: linear-gradient(to left, #eb6100, #b60005);
  color: #fff;
}
</style>
<style>
.new-order .btn.btn-order {
  width: 130px;
  font-size: 12px;
  padding: 6px 14.5px;
  font-weight: 600;
  font-family: 'Poppins';
}
</style>
